"use client"

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import mix from '@utils/styles/mix'
import useSWR from 'swr'
import SvgIcon from '@components/shared/svg-icons/SvgIcon'
import storage from '@utils/localStorage'
import checkLogin from '@utils/checkLogin'
import useAccountSummary from '@hooks/user/useAccountSummary'
import { USER_ACCOUNT, USER_MY_BUY_OFFERS, USER_MY_OFFERS } from '@constants/routes'
import AccountNav, { AccountCard } from './AccountNav'

import styles from './AccountShell.module.css'

const HOST = process.env.NEXT_PUBLIC_HOST

// formularze ogłoszeń mają własny układ
const OWN_LAYOUT = [USER_MY_OFFERS + '/edytuj/', USER_MY_OFFERS + '/wystaw-podobne/', USER_MY_BUY_OFFERS + '/edytuj/']

export function isAccountPath (path = '') {
    return (path === USER_ACCOUNT || path.startsWith(USER_ACCOUNT + '/')) && !OWN_LAYOUT.some(prefix => path.startsWith(prefix))
}

export function AccountSide ({ user, summary }) {
    return (
        <>
            <AccountCard user={user} />
            <AccountNav brief summary={summary} user={user} />
        </>
    )
}

// Strony konta: menu boczne od 1024 px, na telefonie „‹ Konto” prowadzi do listy sekcji (/profil).
export default function AccountShell ({ children }) {
    const path = usePathname() || ''
    const { data: user } = useSWR('user', storage)
    const loggedIn = checkLogin(user)
    const account = isAccountPath(path)
    // liczby do menu bocznego tylko na stronach konta
    const summary = useAccountSummary(user, loggedIn && account)

    if (!account) return children
    const isHome = path === USER_ACCOUNT
    // gość (np. Obserwowane z tej przeglądarki): bez menu konta, powrót na stronę główną
    const guest = user !== undefined && !loggedIn

    return (
        <div className={styles.shell}>
            <div className={mix([styles.acct, guest && styles.guest])}>
                { !guest && (
                    <aside aria-label="Moje konto" className={styles.side}>
                        { loggedIn && <AccountSide summary={summary} user={user} /> }
                    </aside>
                ) }
                <div className={styles.main}>
                    { guest
                        ? <Link className={styles.back} href={HOST + '/'} prefetch={false}><SvgIcon name="chev-l" size="sm" />Strona główna</Link>
                        : !isHome &&
                        <Link className={styles.back} href={HOST + USER_ACCOUNT} prefetch={false}>
                            <SvgIcon name="chev-l" size="sm" />Konto
                        </Link> }
                    {children}
                </div>
            </div>
        </div>
    )
}
